export const AUTH_LOGIN_REQUEST = "AUTH_LOGIN_REQUEST";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";
export const AUTH_LOGIN_RESET = "AUTH_LOGIN_RESET";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const AUTH_GOOGLE_LOGIN_REQUEST = "AUTH_GOOGLE_LOGIN_REQUEST";
export const AUTH_GOOGLE_LOGIN_SUCCESS = "AUTH_GOOGLE_LOGIN_SUCCESS";
export const AUTH_GOOGLE_LOGIN_FAIL = "AUTH_GOOGLE_LOGIN_FAIL";
export const AUTH_GOOGLE_LOGIN_RESET = "AUTH_GOOGLE_LOGIN_RESET";

export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAIL = "AUTH_RESET_PASSWORD_FAIL";
export const AUTH_RESET_PASSWORD_RESET = "AUTH_RESET_PASSWORD_RESET";

export const AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_REQUEST =
  "AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_REQUEST";
export const AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_SUCCESS =
  "AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_SUCCESS";
export const AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_FAIL =
  "AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_FAIL";
export const AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_RESET =
  "AUTH_RESET_SEND_RESET_EMAIL_ACCOUNT_RESET";

export const AUTH_VERIFY_RESET_PASSWORD_TOKEN_REQUEST =
  "AUTH_VERIFY_RESET_PASSWORD_TOKEN_REQUEST";
export const AUTH_VERIFY_RESET_PASSWORD_TOKEN_SUCCESS =
  "AUTH_VERIFY_RESET_PASSWORD_TOKEN_SUCCESS";
export const AUTH_VERIFY_RESET_PASSWORD_TOKEN_FAIL =
  "AUTH_VERIFY_RESET_PASSWORD_TOKEN_FAIL";
export const AUTH_VERIFY_RESET_PASSWORD_TOKEN_RESET =
  "AUTH_VERIFY_RESET_PASSWORD_TOKEN_RESET";

export const AUTH_UPDATE_PASSWORD_REQUEST = "AUTH_UPDATE_PASSWORD_REQUEST";
export const AUTH_UPDATE_PASSWORD_SUCCESS = "AUTH_UPDATE_PASSWORD_SUCCESS";
export const AUTH_UPDATE_PASSWORD_FAIL = "AUTH_UPDATE_PASSWORD_FAIL";
export const AUTH_UPDATE_PASSWORD_RESET = "AUTH_UPDATE_PASSWORD_RESET";

export const AUTH_VERIFY_LOGIN_CODE_REQUEST = "AUTH_VERIFY_LOGIN_CODE_REQUEST";
export const AUTH_VERIFY_LOGIN_CODE_SUCCESS = "AUTH_VERIFY_LOGIN_CODE_SUCCESS";
export const AUTH_VERIFY_LOGIN_CODE_FAIL = "AUTH_VERIFY_LOGIN_CODE_FAIL";
export const AUTH_VERIFY_LOGIN_CODE_RESET = "AUTH_VERIFY_LOGIN_CODE_RESET";

export const AUTH_SELECT_ACCOUNT_LOGIN_REQUEST =
  "AUTH_SELECT_ACCOUNT_LOGIN_REQUEST";
export const AUTH_SELECT_ACCOUNT_LOGIN_SUCCESS =
  "AUTH_SELECT_ACCOUNT_LOGIN_SUCCESS";
export const AUTH_SELECT_ACCOUNT_LOGIN_FAIL = "AUTH_SELECT_ACCOUNT_LOGIN_FAIL";
export const AUTH_SELECT_ACCOUNT_LOGIN_RESET =
  "AUTH_SELECT_ACCOUNT_LOGIN_RESET";

export const AUTH_SWITCH_TENANT_REQUEST = "AUTH_SWITCH_TENANT_REQUEST";
export const AUTH_SWITCH_TENANT_SUCCESS = "AUTH_SWITCH_TENANT_SUCCESS";
export const AUTH_SWITCH_TENANT_FAIL = "AUTH_SWITCH_TENANT_FAIL";
export const AUTH_SWITCH_TENANT_RESET = "AUTH_SWITCH_TENANT_RESET";
